import { ReactNode } from 'react';
import { View } from 'react-native';

type Props = {
  grid: ReactNode;
  videoPlayer: ReactNode;
};

export const Understanding = ({ grid, videoPlayer }: Props) => {
  return (
    <View className="flex-1 flex-row">
      <View className="flex-[2]">{grid}</View>
      {videoPlayer && <View className="flex-[1] flex">{videoPlayer}</View>}
    </View>
  );
};
